import { ApiService } from '../../common'

export class AppDocumentNumbersApi extends ApiService {}
